








































import { MissionExecutionCountEntity } from '@/entities/mission-execution-count.entity';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Mission1 from '@/assets/icons/mission1.png';
import Mission2 from '@/assets/icons/mission2.png';
import Mission3 from '@/assets/icons/mission3.png';
import Clear from '@/assets/icons/icon_clear.png';

@Component({})
export default class MissionDetailItem extends Vue {
  @Prop({ type: Object as PropType<MissionExecutionCountEntity> })
  result: MissionExecutionCountEntity;

  @Prop()
  content: string;

  @Prop()
  index: number;

  Mission1Image = Mission1;
  Mission2Image = Mission2;
  Mission3Image = Mission3;
  clearIcon = Clear;

  get getImage() {
    switch (this.index) {
      case 0:
        return Mission1;
      case 1:
        return Mission2;
      case 2:
        return Mission3;
      default:
        return Mission1;
    }
  }

  // get getContent() {
  //   return this.$t('mission.item.content', { content: this.content });
  // }

  get isClear(): boolean {
    if (!this.result) return false;
    return this.result.isClearMission;
  }

  get percent(): number {
    if (!this.result) return 0;
    return this.result.percent;
  }

  get exected(): number {
    if (!this.result) return 0;
    return this.result.executedCount;
  }

  get progressContent() {
    const percent = this.result?.percent ?? 0;
    switch (true) {
      case percent < 50:
        return this.$t('mission.startMission');
      case percent < 100:
        return this.$t('mission.fiftyPercent', { times: this.exected });
      default:
        return this.$t('mission.clearMission');
    }
  }
}
